import React from 'react';

import { Row } from 'ui';

import logo from 'assets/images/pictures/brands/partOf.jpg';

import style from './attachmentTop.module.scss';

const AttachmentTop = () => {
  return (
    <Row
      align="center"
      justify="center"
      className={style.footerAttachmentTopWrapper}
    >
      <Row
        align="center"
        justify="stretch"
        smDirection="column"
        smAlign="center"
        noWrap
        className={style.footerAttachmentContainer}
      >
        <a
          target="_blank"
          href="https://easy.com/"
          className={style.footerLogo}
          rel="noreferrer"
        >
          <img src={logo} alt="logo" />
        </a>
      </Row>
    </Row>
  );
};

export default AttachmentTop;
